// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Interne Module
import * as storage from '@/_helper/storage';
import { CheckIfImageExists } from '@/_helper//checkImage';
import { AppContext } from '@/context/AppContext';

// Komponenten
import { countdownContainer } from '@/comp/countdownContainer';

// Styles
import './heroTeaser.scss';

class HeroTeaser extends Component {
    static contextType = AppContext;
    #fallbackImage = 'https://staedtereisen.aurumtours.de/img/region/emotion_portal/fallback_beach_neutral_header.jpg';

    constructor(props) {
        super(props);

        this.state = {
            state: this.props.state === undefined ? 'region' : this.props.state,
            heroImage: this.#fallbackImage,
            altText: this.props.altText || undefined,
        };

        this.handleError = this.handleError.bind(this);
    }

    componentDidMount() {
        if (this.props.src !== undefined) {
            this.setState({
                heroImage: this.props.src,
            });
        }

        if (
            storage.get('bookingData') !== null &&
            storage.get('bookingData').data !== null &&
            this.props.src === undefined
        ) {
            switch (this.context?.travelType) {
                case 'package':
                    this.setPackageImage();
                    break;
                case 'cruise':
                    this.setCrusieImage();
                    break;
                default:
                    break;
            }
        }
    }

    setPackageImage() {
        const bookingData = storage.get('bookingData');

        const getHeroImageFromAutocompleter = (getDestination) => {
            let $this = this;
            let url =
                window.$requestUrl +
                '/autocompleter/multiDestination?withDestinations=1&withHotels=0&search=' +
                getDestination;

            if (getDestination !== undefined) {
                axios({
                    url: url,
                    method: 'GET',
                    callbackParamName: 'dp',
                })
                    .then((response) => response)
                    .then((data) => {
                        let d = data.data.slice(0, -1);
                        let r = d.replace(/^dp\(|\)$/g, '');

                        if (JSON.parse(r) !== undefined) {
                            let json = JSON.parse(r);

                            let destination = null;

                            if (json.destinations !== undefined) {
                                let getDestinations = _.filter(json.destinations, function (o) {
                                    return o.regionName === getDestination;
                                });

                                if (getDestinations.length > 0) {
                                    destination = getDestinations[0];
                                } else {
                                    destination = json.destinations[0];
                                }

                                if (destination !== null) {
                                    let regionImagePath = destination.regionImagePath;
                                    let regionImage = destination.regionImageurl;

                                    let customerAreaImagePath = destination.customerAreaImagePath;
                                    let customerAreaImageUrl = destination.customerAreaImageUrl;

                                    $this.setState({
                                        heroImage: {
                                            region: {
                                                p: `https://staedtereisen.aurumtours.de${regionImagePath.p}${regionImage}`,
                                                m: `https://staedtereisen.aurumtours.de${regionImagePath.m}${regionImage}`,
                                            },
                                            customerArea: {
                                                p: `https://staedtereisen.aurumtours.de${customerAreaImagePath.p}/${customerAreaImageUrl}`,
                                                m: `https://staedtereisen.aurumtours.de${customerAreaImagePath.m}/${customerAreaImageUrl}`,
                                            },
                                        },
                                    });

                                    let bookingDataWithHeroImage = _.assign(storage.get('bookingData'), {
                                        heroImage: {
                                            region: {
                                                p: `https://staedtereisen.aurumtours.de${regionImagePath.p}${regionImage}`,
                                                m: `https://staedtereisen.aurumtours.de${regionImagePath.m}${regionImage}`,
                                            },
                                            customerArea: {
                                                p: `https://staedtereisen.aurumtours.de${customerAreaImagePath.p}/${customerAreaImageUrl}`,
                                                m: `https://staedtereisen.aurumtours.de${customerAreaImagePath.m}/${customerAreaImageUrl}`,
                                            },
                                        },
                                    });

                                    storage.set('bookingData', bookingDataWithHeroImage);
                                }
                            }
                        }
                    })
                    .catch(() => {
                        this.handleError();
                    });
            }
        };

        if (bookingData?.heroImage !== undefined) {
            let heroImage = storage.get('bookingData').heroImage;
            let image = this.#fallbackImage;

            // set image
            switch (this.state.state) {
                case 'region':
                    image = window.$browserInfo.device === 'mobile' ? heroImage.region?.m : heroImage.region?.p;
                    break;
                case 'customerarea':
                    image =
                        window.$browserInfo.device === 'mobile' ? heroImage.customerArea?.m : heroImage.customerArea?.p;
                    break;
                default:
            }

            CheckIfImageExists(image, (exists) => {
                if (exists) {
                    this.setState({
                        heroImage: bookingData.heroImage,
                    });
                }
            });
        } else {
            if (bookingData?.data?.frontendParams !== undefined) {
                if (_.last(bookingData.data.frontendParams?.hotelDetails) !== undefined) {
                    let getDestination = _.last(bookingData?.data?.frontendParams?.hotelDetails).areaDescription;
                    if (getDestination !== undefined) {
                        getHeroImageFromAutocompleter(getDestination);
                    }
                }
            }
        }
    }

    setCrusieImage() {
        const rootCruiseImagePath = './assets/images/cruise/ship-images';
        const bookingData = storage.get('bookingData');
        let { cruise } = bookingData?.data?.frontendParams;

        let cruiseImageObj = {
            cruiseImage: `${rootCruiseImagePath}/${cruise?.providerCode}/${window.$browserInfo.device === 'mobile' ? 'mobile' : 'desktop'}/${cruise?.atsCode}_${cruise?.providerCode}.jpg`,
            customerArea: {
                p: `${rootCruiseImagePath}/fallback_cruises_kundenbereich-desktop.jpg`,
                m: `${rootCruiseImagePath}/fallback_cruises_kundenbereich-mobile.jpg`,
            },
        };

        CheckIfImageExists(cruiseImageObj.cruiseImage, (exists) => {
            if (exists) {
                cruiseImageObj = {
                    customerArea: {
                        p: cruiseImageObj.cruiseImage,
                        m: cruiseImageObj.cruiseImage,
                    },
                };
            }
            this.setState({
                heroImage: cruiseImageObj,
            });
        });
    }

    handleError() {
        this.setState({ heroImage: this.#fallbackImage });
    }

    getAltText() {
        switch (this.context?.travelType) {
            case 'package':
                return 'Bild der Unterkunft';
            case 'cruise':
                return 'Bild des Kreuzfahrtschiffes';
            default:
                return 'Bild';
        }
    }
    getInnerContent() {
        switch (this.props.bookingState) {
            case 'OK':
                return (
                    <>
                        {this.context?.travelType === 'cruise' && (
                            <figcaption className="image-disclaimer">
                                Beispielhafte Darstellung Ihres Schiffes
                            </figcaption>
                        )}
                        {countdownContainer(this.props.depDate)}
                    </>
                );
            case 'over':
                return <div className="status-info">Ihre Reise ist abgeschlossen</div>;
            case 'XX':
                return <div className="status-info">Die Buchung wurde storniert</div>;
            default:
                break;
        }
    }

    render() {
        const { state, heroImage, altText } = this.state;
        let image = heroImage;

        // set image
        switch (state) {
            case 'region':
                image = window.$browserInfo.device === 'mobile' ? heroImage.region?.m : heroImage.region?.p;
                break;
            case 'customerarea':
                image = window.$browserInfo.device === 'mobile' ? heroImage.customerArea?.m : heroImage.customerArea?.p;
                break;
            default:
        }

        return (
            <figure className={`hero-image ${this.props.bookingState || ''}`}>
                <LazyLoadImage
                    wrapperClassName="lazy-load-background"
                    src={image ?? this.#fallbackImage}
                    alt={altText || this.getAltText()}
                    effect={this.props.effect ? this.props.effect : ''}
                />
                {this.getInnerContent()}
            </figure>
        );
    }
}

export default HeroTeaser;
